var rutasSinConexion = ['recuperar-clave'];

export default rutasSinConexion;
